const MobileCard = ({ title, description, name, city, backgroundColor }) => {
  return (
    <div
      className="flex-shrink-0 rounded-lg"
      style={{
        width: "311px",
        height: "380px",
        backgroundColor: backgroundColor || "#fff",
        padding: "32px",
      }}
    >
      <div className="flex flex-col h-full justify-between">
        <div>
          <h2 className="font-helvetica font-semibold text-[20px] leading-[28px] mb-5 text-[#21272A]">
            {title}
          </h2>
          <p
            style={{ fontFamily: "Georgia, serif" }}
            className="text-[22px] leading-[32px] mt-4 text-[#21272A] tracking-tight"
          >
            {description}
          </p>
        </div>

        <div>
          <h3 className="font-helvetica font-bold text-[16px] leading-[24px] text-[#21272A] mb-1">
            {name}
          </h3>
          <p className="font-helvetica text-[14px] leading-[20px] text-[#697077]">
            {city}
          </p>
        </div>
      </div>
    </div>
  );
};

export default MobileCard;
